import { render, staticRenderFns } from "./distributing2.vue?vue&type=template&id=20336e19&scoped=true&"
import script from "./distributing2.vue?vue&type=script&lang=js&"
export * from "./distributing2.vue?vue&type=script&lang=js&"
import style0 from "./distributing2.vue?vue&type=style&index=0&id=20336e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20336e19",
  null
  
)

export default component.exports